export default __webpack_public_path__ + "static/media/shape-spatula.51cdabab.PNG";